import { useState } from "react";
import { MdCheckBoxOutlineBlank, MdCheckBox } from "react-icons/md";
import RightTimeApi from "@/API";
import { toast } from "react-toastify";
import Enums from "@/enums";

export default function SiteJobsTable(props: any) {
  const showDepartmentColumn = !!props.departmentsEnabled;
  const canEdit = props.adminPerms?.includes(Enums.ROLE_PERMS.EditSite)
    || props.adminPerms?.includes(Enums.ROLE_PERMS.CompanyAdmin)
    || props.adminPerms?.includes(Enums.ROLE_PERMS.SystemAdmin);
  async function toggleSiteJobActiveAsync(e) {
    if (!canEdit) return;
    let data = {
      siteId: parseInt(e.currentTarget.getAttribute("data-siteid")),
      companyJobId: parseInt(e.currentTarget.getAttribute("data-jobid")),
    };
    const resp = await RightTimeApi.putAsync("/SiteJobActiveToggle", data);
    if (resp && resp.ok) {
      if(resp.jsonData.active)
        toast.success("Job '" + resp.jsonData.jobName + "' activated for " + resp.jsonData.siteName);
      else
        toast.success("Job '" + resp.jsonData.jobName + "' de-activated for " + resp.jsonData.siteName);
      props.getCompanySites();
    };
  }

  async function toggleAllJobsAsync() {
    if (!canEdit) return;
    // debugger;
    await RightTimeApi.postAsync("/SiteJobActiveToggle/"+props.activeSite.id );
    props.getCompanySites();
  }

  return (
    <div className="tableWrapper factTable horizontal scrollable siteJobsTable">

    <table>
      <caption>
        <span className="title">{props.subEntityTypeName || "Site"} / Jobs</span>
      </caption>
      <thead>
        <tr>
          <th>Job Name</th>
          {showDepartmentColumn ? <th>Department</th> : null}
          <th
            className="toggleColumnHeader"
            data-help-id="toggleActive"
            onClick={toggleAllJobsAsync}
            style={{ cursor: canEdit ? "pointer" : "default" }}
          >
            Access
          </th>
        </tr>
      </thead>
      <tbody>
        {props.jobs && props.activeSite && props.activeSite.id
          ? props.jobs.map((job) => {
              const jobId = job.id ?? job.key;
              const jobName = job.name ?? job.value;
              let siteJob = props.siteJobs.find(
                (sj) =>
                  sj.siteId === props.activeSite.id && sj.jobId === jobId
              );
              return (
                <tr key={"job" + jobId}>
                  <td className="Name">{jobName}</td>
                  {showDepartmentColumn ? (
                    <td className={`companyJobDepartmentCell${!(job.departmentIds?.length || job.departmentId) ? " missingDepartment" : ""}`}>
                      {job.departmentName || "—"}
                    </td>
                  ) : null}
                  <td
                    className="actions"
                    data-jobid={jobId}
                    data-siteid={props.activeSite.id}
                    onClick={toggleSiteJobActiveAsync}
                  >
                    {siteJob ? (
                      <MdCheckBox className={`checkbox checked actionIcon${canEdit ? "" : " disabled"}`} />
                    ) : (
                      <MdCheckBoxOutlineBlank className={`checkbox unchecked actionIcon${canEdit ? "" : " disabled"}`} />
                    )}
                  </td>
                </tr>
              );
            })
          : null}
      </tbody>
    </table>
    </div>
  );
}

